const EventLoggingEndpoint = {
  LOG_FRONTEND_EVENT: '/event-logging/log',
  LOG_USER_SPECIFIC_FRONTEND_EVENT: '/event-logging/log-user-specific',
};

export default EventLoggingEndpoint;
